export default "__VITE_ASSET__SIz7_Ki2__"